module.exports = __webpack_public_path__ + "static/media/nrJ1SucfIl.b0a6b145.jpg";